import React from "react";
import "./HowitworksHero.css";

/**
 * Hero for the "How It Works" page (Emerald Appraisal Services)
 *
 * Props:
 * - background?: string   custom background image (path or URL)
 * - title?: string        main heading
 * - ctaText?: string      button text
 * - onCta?: () => void    CTA handler
 */
export default function HowitworksHero({
  background,
  title = "How Emerald Process Works",
  ctaText = "Send Us a Message",
  onCta = () => (window.location.href = "/contact"),
}) {
  // Default image from /public using process.env.PUBLIC_URL
  const defaultBackground = `${process.env.PUBLIC_URL || ""}/hwhd.jpg`;
  const finalBackground = background || defaultBackground;

  return (
    <section
      className="HowitworksHero"
      style={{ "--hiw-bg": `url(${finalBackground})` }}
      aria-label="How Emerald Process Works"
      role="banner"
    >
      {/* overlays */}
      <div className="HowitworksHero__overlay" aria-hidden="true" />
      <div className="HowitworksHero__pattern" aria-hidden="true" />

      <div className="HowitworksHero__container">
        {/* Breadcrumbs */}
        <nav className="HowitworksHero__crumbs" aria-label="Breadcrumb">
          <ol>
            <li><a href="/">Home</a></li>
            <li aria-hidden="true" className="HowitworksHero__sep">›</li>
            <li aria-current="page">How It Works</li>
          </ol>
        </nav>

        {/* Title + CTA */}
        <div className="HowitworksHero__center">
          <h1 className="HowitworksHero__title">{title}</h1>

          {/* Client-requested service line */}
          <p className="HowitworksHero__service-line">
            We complete appraisals for purchases and refinances.
          </p>
        </div>
      </div>
    </section>
  );
}
